// Module
var code = "<img class=\"cf-image\" ng-if=\"model.hasImage\" storable-image=\"{{src}}\">";
// Exports
export default code;